import { useEffect, useRef } from 'react';

export interface NixlabsAccountWidgetProps {}
export function NixlabsAccountWidget() {
  const mount = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = document.createElement('nixlabs-account');
    element.setAttribute('placement', 'inline');

    mount.current?.appendChild(element);
    return () => { element.remove(); };
  }, []);
  return <div ref={mount} className="nixlabs-account-widget" />;
}
